import { call } from 'redux-saga/effects';

import * as pageStateService from '../page-state/page-state.saga-services';
import * as pageInitializerService from '../page.initializer.saga-service';

import * as kpiService from '../page-storage/kpi/kpi.saga-services';
import { IMeetingSimple } from '../../resource/meeting-simple/meeting-simple.types';

export function* initialKpiPage(meetingId: IMeetingSimple['id']) {
  yield call(pageStateService.initPage, 'kpi');
  if (!((yield call(pageInitializerService.initPage)) as boolean)) {
    yield call(kpiService.setupKpi, meetingId);
  }
  yield call(pageStateService.completedInit, 'kpi');
}
